/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIcsAdapter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.661 3.145a2.676 2.676 0 0 1 3.654-.99 2.676 2.676 0 0 1 .83 3.876l.938 1.62a2.646 2.646 0 0 1 2.09.697l2.068-.892a2.683 2.683 0 0 1 .357-1.49 2.676 2.676 0 0 1 3.653-.99 2.676 2.676 0 0 1 .97 3.66 2.676 2.676 0 0 1-4.135.633l-2.067.893a2.683 2.683 0 0 1-.358 1.49 2.676 2.676 0 0 1-4.14.628l-2.222.942a2.683 2.683 0 0 1-.357 1.483 2.676 2.676 0 0 1-3.654.99 2.677 2.677 0 0 1-.97-3.66 2.677 2.677 0 0 1 4.14-.629l2.222-.942a2.683 2.683 0 0 1 .635-1.876L8.46 7.112a2.648 2.648 0 0 1-1.83-.309 2.676 2.676 0 0 1-.97-3.658zm2.654.743a.677.677 0 0 0-.922.257c-.193.334-.075.745.238.926s.729.077.922-.257a.677.677 0 0 0-.238-.926zm9.937 2.821a.676.676 0 0 0-.922.257.677.677 0 0 0 .238.927c.313.18.729.076.921-.257a.676.676 0 0 0-.238-.927zm-6.56 3.016a.676.676 0 0 0-.922.257.676.676 0 0 0 .238.927c.313.18.729.076.921-.258s.075-.745-.238-.926zm-6.72 3.053a.677.677 0 0 0-.922.257c-.193.334-.075.746.238.927s.729.077.921-.257a.676.676 0 0 0-.238-.927zM16.5 15a2.5 2.5 0 1 0 0 5H18v-5zm3.5 2v1h2v2h-2v2h-3.5a4.502 4.502 0 0 1-4.388-3.5H10v-2h2.111A4.502 4.502 0 0 1 16.5 13H20v2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIcsAdapter as IcsAdapter };
